import React, { useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { setDefaultSearchResults } from "../../actionCreators/boostCommerceAC";
import SearchTerms from "./SearchTerms";
import { mapRecentSearches, sendGroupBySearchEvent, setRecentSearch } from "../helpers";
import ProductVariation from "../../PDP/Columns/ProductVariation";
import _ from "underscore";
import { getCookie } from "../../common/utils";
import Button from "react-bootstrap/Button";
import NumberFormat from "react-number-format";
import SearchSkeletonPlaceholder from "./SearchSkeletonPlaceholder";
import { noScroll } from "../../actionCreators/appAC";
import Container from "react-bootstrap/Container";

const SearchMenu = React.memo((props) => {
    const { mobile, top_promo_banner_not_visible, inputFocused, searchBarRef, searchQuery, handleOutsideClick, setIsLoading, isLoading, isTyping } = props;
    if (!inputFocused) return null;
    const recentSearches = getCookie("recentSearches") ? mapRecentSearches(JSON.parse(getCookie("recentSearches"))) : [];
    const {
        defaultSearchTerms,
        defaultSearchProducts,
        defaultDesigners,
        suggestedSearchTerms,
        searchProductResults,
        suggestedDesigners,
        plpTotalSearchProducts,
    } = useSelector((state) => state.shopifyReducer, shallowEqual);
    const { isInternational, isUsdInternational } = useSelector((state) => ({
        isInternational: state.appReducer.isInternational,
        isUsdInternational: state.appReducer.isUsdInternational,
    }), shallowEqual);
    const searchResults = suggestedSearchTerms.length ? suggestedSearchTerms : recentSearches.length > 2 ? recentSearches : defaultSearchTerms;
    const searchResultsTitle = suggestedSearchTerms.length ? "Suggestions" : recentSearches.length > 2 ? "Recent Searches" : "Popular Searches";
    const dispatch = useDispatch();
    const is_b2b = getCookie("is_b2b");
    const is_wholesale_active = getCookie("is_wholesale_active");
    const noSearchResults = searchQuery && !isTyping && searchProductResults.length === 0;
    const processedDefaultSearchProducts = searchProductResults.length === 0 ? searchQuery && !isTyping ? defaultSearchProducts.slice(0, mobile ? 4 : 3) : defaultSearchProducts : searchProductResults;

    const handleViewAllClick = () => {
        if (searchQuery) setRecentSearch(searchQuery);
        searchBarRef.current.submit();
    };

    useEffect(() => {
        dispatch(setDefaultSearchResults(mobile, setIsLoading));
        return () => {
            dispatch(noScroll(false));
        }
    }, [mobile]);


    useEffect(() => {
        const nonUsd = isInternational ? !isUsdInternational : false;
        sendGroupBySearchEvent(searchQuery, searchProductResults, nonUsd, true);
    }, [searchProductResults]);

    return (
        <div className={`search-menu ${top_promo_banner_not_visible ? "" : "with-top-banner"}`}>
            {isLoading ?
                <SearchSkeletonPlaceholder/>
                :
                <Container className="search-menu__inner-container">
                    <div className="search-menu__left">
                        <div className="search-menu__left-block">
                            <h4 className="search-menu__title search-menu__title--left">{searchResultsTitle}</h4>
                            <SearchTerms searchTerms={searchResults} searchQuery={searchQuery} />
                        </div>
                        <div className="search-menu__left-block">
                            {(suggestedDesigners.length > 0 || defaultDesigners.length > 0) && <h4 className="search-menu__title search-menu__title--left">Designers</h4>}
                            <SearchTerms searchTerms={suggestedDesigners.length ? suggestedDesigners : defaultDesigners} searchQuery={searchQuery} />
                        </div>
                    </div>
                    <div className="search-menu__right">
                        {noSearchResults &&
                            <div className="search-menu__product-warning">
                                Sorry, no products matched your selection. These suggestions might interest you.
                            </div>
                        }
                        <div className="search-menu__product-list">
                            {_.map(processedDefaultSearchProducts, (product) => {
                                return (
                                    <ProductVariation
                                        key={product.id}
                                        product_variation={product}
                                        is_b2b={is_b2b}
                                        is_wholesale_active={is_wholesale_active}
                                        customClass="search-menu__product"
                                    />
                                );
                            })}
                        </div>
                        {plpTotalSearchProducts > 6 &&
                            <Button
                                className="search-menu__view-all-bags rbg-btn-ghost"
                                variant="clean"
                                onClick={() => handleViewAllClick()}
                            >
                                View all <NumberFormat value={plpTotalSearchProducts} displayType={"text"} thousandSeparator={true} /> items
                            </Button>
                        }
                        {/*{!mobile &&*/}
                        {/*    <Button*/}
                        {/*        className="search-menu__close"*/}
                        {/*        variant="clean"*/}
                        {/*        onClick={() => handleOutsideClick()}*/}
                        {/*    >*/}
                        {/*        <CleanCrossIcon*/}
                        {/*            style={{ width: 25 }}*/}
                        {/*            label="Close"*/}
                        {/*            stroke="#000000"*/}
                        {/*        />*/}
                        {/*    </Button>*/}
                        {/*}*/}
                    </div>
                </Container>
            }
        </div>
    );
});

export default SearchMenu;